import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { BrowserRouter } from "react-router";
import { AppRouter } from './app/AppRouter';
import { Provider } from "react-redux";
import store from './app/store';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

// React Date Range Styles
import "react-date-range/dist/styles.css"; // Estilos principales
import "react-date-range/dist/theme/default.css"; // Tema por defecto

// Theme System
import { ThemeProvider, ThemeGuard } from './context';
import './styles/themes.scss';
import { ErrorBoundary } from './components/ErrorBoundary';

console.log('🚀 App.tsx loading...');

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Habilita el flag experimental
      experimental_prefetchInRender: true,
    }
  }
})

function App() {
  console.log('🎯 App component executing');
  console.log('Environment check:', {
    NODE_ENV: import.meta.env.MODE,
    API_URL: import.meta.env.VITE_API_URL,
    LOGIN_URL: import.meta.env.VITE_LOGIN_URL,
    hasAllEnvVars: !!(import.meta.env.VITE_API_URL && import.meta.env.VITE_LOGIN_URL)
  });

  return (
    <ErrorBoundary>
      <ThemeProvider defaultTheme="system">
        <ThemeGuard>
          <Provider store={store}>
            <BrowserRouter>
              <QueryClientProvider client={queryClient}>
                <AppRouter />
                <ToastContainer
                  position="top-center"
                  autoClose={4000}
                  hideProgressBar={false}
                  closeOnClick
                  pauseOnHover
                />
              </QueryClientProvider>
            </BrowserRouter>
          </Provider>
        </ThemeGuard>
      </ThemeProvider>
    </ErrorBoundary>
  )
}

export default App
